<template>
    <div>
        <configs-content :loading="!loaded">
            <h2 class="flex items-center text-3xl mb-4">
                <nio-icon class="mr-2" name="regular/alarm-bell" />
                {{ $t('configs.rightPanel.notifications.subtitles.notifications') }}
            </h2>

            <div class="flex flex-col w-full border border-gray-200 rounded">
                <div class="flex items-center p-4 border-b border-gray-200 rounded-t bg-gray-100">
                    <div class="w-1/2">
                        {{ $t('configs.rightPanel.notifications.type') }}
                    </div>
                    <div class="w-1/4 flex justify-center items-center">
                        <nio-icon class="mr-2" name="regular/screen-1" />
                        <span>{{ $t('configs.rightPanel.notifications.screen') }}</span>
                    </div>
                    <div class="w-1/4 flex justify-center items-center">
                        <nio-icon class="mr-2" name="regular/envelope" />
                        <span>{{ $t('configs.rightPanel.notifications.email') }}</span>
                    </div>
                </div>

                <div class="flex flex-col items-center w-full h-full">
                    <div class="flex items-center w-full p-4 | transition duration-300 hover:bg-gray-100">
                        <div class="w-1/2">
                            {{ $t('configs.rightPanel.notifications.newMessageConfirmation') }}
                        </div>
                        <div class="w-1/4 flex justify-center items-center">
                            <input
                                class="form-checkbox"
                                type="checkbox"
                                v-model="user.options.notifications.message_received.screen"
                            >
                        </div>
                        <div class="w-1/4 flex justify-center items-center">
                            <input
                                class="form-checkbox"
                                type="checkbox"
                                v-model="user.options.notifications.message_received.email"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </configs-content>

        <configs-footer>
            <nio-button
                color="blue"
                :disabled="!loaded"
                :loading="saving"
                @click="saveConfigs"
            >
                {{ $t('global.general.save') }}
            </nio-button>
        </configs-footer>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import cloneDeep from 'lodash/cloneDeep.js';
    import assign from 'lodash/assign.js';
    import ConfigsContent from '@/components/ConfigsContent.vue';
    import ConfigsFooter from '@/components/ConfigsFooter.vue';

    export default {
        components: {
            ConfigsContent,
            ConfigsFooter,
        },

        data() {
            return {
                saving: false,
                loaded: false,
                user: {
                    id: null,
                    options: {
                        unsubscribe_message: {
                            fr: '',
                            en: '',
                        },
                        confirmation_message: {
                            fr: '',
                            en: '',
                        },
                        quick_send: true,
                        notifications: {
                            message_received: {
                                email: false,
                                screen: true,
                            },
                        },
                    },
                },
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        watch: {
            authUser(newValue) {
                this.mergeWithoutAdding(this.user, newValue);

                this.$nextTick(() => {
                    this.loaded = true;
                });
            },
        },

        methods: {
            ...mapActions([
                'setAuthUser',
            ]),

            ...mapActions('setting', [
                'updateUser',
            ]),

            saveConfigs() {
                this.saving = true;

                this.updateUser(this.user)
                    .then(user => {
                        this.saving = false;

                        // Update authUser
                        const newAuthUser = assign(cloneDeep(this.authUser), user);
                        this.setAuthUser(newAuthUser);

                        this.$notify.show({
                            type: 'success',
                            message: this.$t('configs.rightPanel.notifications.messages.updateSuccessful'),
                        });
                    })
                    .catch(() => {
                        this.saving = false;

                        this.$notify.show({
                            type: 'error',
                            message: this.$t('configs.rightPanel.notifications.errors.update'),
                        });
                    });
            },
        },
    };
</script>
